import React from 'react';
import PrivacyPolicyEditSection from '../../../sections/AdminDashboard/Content/PrivacyPolicyEdit';

const PrivacyPolicyEdit = () => {
  return <PrivacyPolicyEditSection />;
};

export default PrivacyPolicyEdit;

